<div [ngClass]="{ 'price-display-container': !allowCustomStyling }">
  <!-- TODO do this better in MIT-1542 -->
  @if (!priceUnavailable) {
    <div
      class="price-top-info"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'large-top-info': isCardView,
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start',
        'fixed-height-top-label': fixedTopHeight,
      }"
    >
      @if (topLabel) {
        {{ topLabelDisplay }}
      }
    </div>
    <div
      class="price-mid-info"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start',
        'large-mid-info': isCardView,
      }"
    >
      @if (!hasStairStepPricing || !isCardView) {
        <div>
          @if (multiFrequency) {
            @for (price of prices; track $index) {
              @if (
                !contactSales &&
                (price.price !== 0 || alwaysShowNumber) &&
                ((!allowNegativePrice && price.price >= 0) || allowNegativePrice)
              ) {
                <div class="price-main-row">
                  @if ($index > 0) {
                    <span>+</span>
                  }
                  <glxy-frequency
                    [value]="price.price | priceInDollars: currencyCode : 'en-US'"
                    [currencyCode]="currencyCode | resolveCurrencyCode: 'en-US'"
                    [form]="frequencyForm"
                    [align]="align"
                    [frequency]="price.frequency"
                    [size]="size"
                    [allowCustomStyling]="allowCustomStyling"
                    [ngClass]="{
                      'large-inner-frequency': isCardView,
                      'link-popover': shouldShowPopover,
                      'align-center': align.toLowerCase() === 'center',
                      'negative-price': price.price < 0,
                      'green-price': price.price > 0 && showGreenPrice,
                    }"
                    (mouseenter)="displayPopover()"
                    (mouseleave)="showingPopover = false"
                    [glxyPopover]="popover"
                  ></glxy-frequency>
                </div>
              }
              @if (contactSales || (!price.price && prices.length === 1 && !alwaysShowNumber)) {
                <span
                  (mouseenter)="displayPopover()"
                  (mouseleave)="showingPopover = false"
                  [glxyPopover]="popover"
                  [ngClass]="{
                    'link-popover': shouldShowPopover,
                    'large-overridden-text': isCardView,
                  }"
                >
                  {{ overriddenValue }}
                </span>
              }
            }
          } @else {
            @if (
              !contactSales &&
              (price || (!price && alwaysShowNumber)) &&
              ((!allowNegativePrice && price >= 0) || allowNegativePrice)
            ) {
              <div class="price-main-row">
                <glxy-frequency
                  [value]="price | priceInDollars: currencyCode : 'en-US'"
                  [currencyCode]="currencyCode | resolveCurrencyCode: 'en-US'"
                  [form]="frequencyForm"
                  [align]="align"
                  [frequency]="frequency"
                  [size]="size"
                  [allowCustomStyling]="allowCustomStyling"
                  [ngClass]="{
                    'large-inner-frequency': isCardView,
                    'link-popover': shouldShowPopover,
                    'align-center': align.toLowerCase() === 'center',
                    'negative-price': price < 0,
                    'green-price': price > 0 && showGreenPrice,
                  }"
                  (mouseenter)="displayPopover()"
                  (mouseleave)="showingPopover = false"
                  [glxyPopover]="popover"
                ></glxy-frequency>
              </div>
            }
          }

          @if (contactSales || (!price && (!prices || prices.length <= 0)) || (price === 0 && shouldShowPopover)) {
            <span
              (mouseenter)="displayPopover()"
              (mouseleave)="showingPopover = false"
              [glxyPopover]="popover"
              [ngClass]="{
                'link-popover': shouldShowPopover,
                'large-overridden-text': isCardView,
              }"
            >
              {{ overriddenValue }}
            </span>
          }
          <glxy-popover
            #popover
            [maxWidth]="'auto'"
            [isOpen]="showingPopover"
            [positions]="[
              popoverPositions.Left,
              popoverPositions.TopLeft,
              popoverPositions.BottomLeft,
              popoverPositions.Top,
              popoverPositions.Right,
            ]"
            [padding]="'small'"
          >
            <glxy-popover-title>{{ popoverTitle }}</glxy-popover-title>
            @if (hasStairStepPricing) {
              <div class="stairstep-container">
                <billing-ui-stairstep-price-display
                  [stairsteps]="stairSteps"
                  [form]="frequencyForm"
                  [align]="'start'"
                  [frequency]="frequency"
                  [size]="size"
                  [currencyCode]="currencyCode"
                ></billing-ui-stairstep-price-display>
              </div>
            }
            @if (initialCommitment && recurringCommitment && hasStairStepPricing) {
              <span>
                <br />
                <strong>Commitment</strong>
                <br />
              </span>
            }
            <span>{{ initialCommitment }}</span>
            @if (initialCommitment && recurringCommitment) {
              <br />
            }
            <span>{{ recurringCommitment }}</span>
            @if (hasDiscounts) {
              <div>
                @if ((initialCommitment && recurringCommitment) || hasStairStepPricing) {
                  <br />
                }
                <billing-ui-discount-display
                  [discounts]="discounts"
                  [currency]="currencyCode"
                  [size]="size"
                ></billing-ui-discount-display>
              </div>
            }
          </glxy-popover>
        </div>
      }
      @if (hasStairStepPricing && isCardView) {
        <div class="stairstep-container">
          <billing-ui-stairstep-price-display
            [stairsteps]="stairSteps"
            [form]="frequencyForm"
            [align]="'start'"
            [frequency]="frequency"
            [size]="size"
            [currencyCode]="currencyCode"
          ></billing-ui-stairstep-price-display>
        </div>
      }
    </div>
    @if (setupFee && setupFee > 0) {
      <div
        class="price-bottom-info"
        [ngClass]="{
          'align-end': align.toLowerCase() === 'end',
          'align-center': align.toLowerCase() === 'center',
          'align-start': align.toLowerCase() === 'start',
        }"
      >
        <span
          [ngClass]="{
            'large-setup-fee-value': isCardView,
          }"
        >
          + {{ setupFee | priceInDollars: currencyCode : 'en-US' }}
        </span>
        <span [ngClass]="{ 'large-setup-fee-label': isCardView }">
          {{ (currencyCode | resolveCurrencyCode: 'en-US') + ' ' + (setupFeeLabelKey | translate) }}
        </span>
      </div>
    }
    <div
      class="price-bottom-info"
      [ngClass]="{
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start',
      }"
    >
      @if (this.prices?.length > 0 && this.fees?.length > 0) {
        <div>
          <span
            [ngClass]="{
              'large-mgmt-fee-value': isCardView,
              'small-mgmt-fee': !isCardView,
            }"
          >
            <span>+ {{ managementFeeLabelKey | translate }}</span>
          </span>
        </div>
      } @else {
        @for (fee of this.fees; track $index) {
          @if (fee.amount > 0) {
            <div id="fees">
              <span
                [ngClass]="{
                  'large-mgmt-fee-value': isCardView,
                  'small-mgmt-fee': !isCardView,
                }"
              >
                @if (fee.amountType === FeeAmountType.FEE_AMOUNT_TYPE_FIXED) {
                  <span id="fixed-fee-value"> + {{ fee.amount | currencyWithoutUSD: currencyCode : 'en-US' }} </span>
                }
                @if (fee.amountType === FeeAmountType.FEE_AMOUNT_TYPE_PERCENTAGE) {
                  <span id="percentage-fee-value"> + {{ fee.amount }}% </span>
                }
              </span>
              <span [ngClass]="{ 'large-mgmt-fee-label': isCardView, 'small-mgmt-fee': !isCardView }">
                @if (componentTextLength === 'short') {
                  <span id="freq-short">
                    {{ managementFeeFrequency }}
                  </span>
                }
                @if (componentTextLength === 'verbose') {
                  <span id="freq-verbose"> &nbsp;{{ managementFeeFrequency }} </span>
                }
                <span id="fee-label">
                  {{ managementFeeLabelKey | translate }}
                </span>
              </span>
            </div>
          }
        }
      }
    </div>
    @if (shouldShowBottomInfo) {
      <div
        [ngClass]="{
          'large-bottom-text': isCardView,
          'align-end': align.toLowerCase() === 'end',
          'align-center': align.toLowerCase() === 'center',
          'align-start': align.toLowerCase() === 'start',
        }"
        id="card-view-commitment"
      >
        <span>{{ initialCommitment }}</span>
        @if (initialCommitment && recurringCommitment) {
          <br />
        }
        <span>{{ recurringCommitment }}</span>
      </div>
    }
    @if (shouldShowBottomInfo && hasDiscounts) {
      <div
        class="card-view-discount"
        [ngClass]="{
          'align-end': align.toLowerCase() === 'end',
          'align-center': align.toLowerCase() === 'center',
          'align-start': align.toLowerCase() === 'start',
        }"
      >
        <billing-ui-discount-display
          [discounts]="discounts"
          [currency]="currencyCode"
          [size]="size"
        ></billing-ui-discount-display>
      </div>
    }
  } @else {
    <div
      [ngClass]="{
        'large-mid-info': isCardView,
        'align-end': align.toLowerCase() === 'end',
        'align-center': align.toLowerCase() === 'center',
        'align-start': align.toLowerCase() === 'start',
        'large-overridden-text': isCardView,
      }"
    >
      {{ overriddenValue }}
    </div>
  }
</div>
